import Splitting from 'splitting'
import Block from './Block'

export default class Button extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    setTimeout(() => {
      this.splitText()
    }, 500)
  }

  getElems() {
    super.getElems()

    this.text = this.el.querySelector('.button__wrapper')
  }

  splitText() {
    /* eslint-disable-next-line */
    this.splittedText = Splitting({ target: this.text, by: 'lines' })

    const secondLine = this.splittedText[0].lines[1]

    if (!secondLine) return

    for (let i = 0; i < secondLine.length; i++) {
      if (i === 0) secondLine[i].classList.add('first')
      if (i === secondLine.length - 1) secondLine[i].classList.add('last')
      secondLine[i].classList.add('line-2')
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Button.js